import React, { useState } from "react";
import { Box, Modal, ModalBody, useToast, useTranslation } from "@familyzone/component-library";
import Api from "../../utils/Api";

const RestartApplianceModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { errorToast, successToast } = useToast();

  const [loading, setLoading] = useState(false);

  const handleRestart = () => {
    setLoading(true);

    Api.post(
      "/managedevice/ajax/device/restart",
      {},
      () => {
        successToast({
          title: t("Restart initiated"),
          description: t("Appliance restart triggered successfully"),
          isClosable: true,
        });

        onClose();
        setLoading(false);
      },
      () => {
        errorToast({
          title: t("Please try again"),
          description: t("Failed to trigger appliance restart"),
          isClosable: true,
        });

        setLoading(false);
      }
    );
  };

  return (
    <Modal
      headerText={t("Restart Appliance")}
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      variant="danger"
      primaryCTALabel={loading ? t("Restarting..") : t("Restart")}
      primaryCTADisabled={loading}
      onPrimaryCTAClick={handleRestart}
      secondaryCTALabel={t("Cancel")}
      secondaryCTADisabled={loading}
      onSecondaryCTAClick={onClose}
    >
      <ModalBody>
        <Box>{t("Manually trigger an appliance restart.")}</Box>
      </ModalBody>
    </Modal>
  );
};

export default RestartApplianceModal;
